import { Component, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { SortableService } from 'shared/sortable/sortable.service';
import * as utils from 'utils/utils';


@Component({
  moduleId: module.id,
  selector: 'attributes-segment',
  templateUrl: 'attributes.component.html',
  styleUrls: ['attributes.component.scss'],
  providers: [SortableService]
})
export class AttributesComponent extends BaseSegmentComponent implements OnChanges {
  headers: any[] = ['name', 'value', 'uom_description', 'style_name'];
  cellsWidth: any = {
    Value: '1*',
    Units: '1*',
    Style: '1*',
  };

  attributes: Array<any> = [];

  ngOnChanges() {
    this.data = this.orderBy(this.data, 'sequence');
    if (this.itemDetail && this.itemDetail.attributes) {
      this.attributes = this.orderBy(this.itemDetail.attributes, 'priority');
      this.setItemsErrorMark(this.data, this.attributes, 'attributes');
    }
  }

  // replace parent method:
  public hasError(path: string, language?: string, index?: number) {
    return utils.hasServerError(this.itemDetail.validation, path, language, index, true);
  }

  // private
  private isArray(obj: any) {
    return obj instanceof Array;
  }

}
